import type { ConnectorProviderType } from "../types/connectors";
import {
  CONNECTOR_PROVIDER_SLUGS,
  connectorAddPath,
  type ConnectorProviderSlug,
} from "./connectorRoutes";

export interface ConnectorProviderTileConfig {
  id: ConnectorProviderType;
  slug: ConnectorProviderSlug;
  title: string;
  description: string;
  addPath: string;
  defaultManagementApiUrl: string;
  showGcpFields: boolean;
  showRuntimeRegion: boolean;
}

export const CONNECTOR_PROVIDER_TILES: ConnectorProviderTileConfig[] = [
  {
    id: "apigee-edge",
    slug: CONNECTOR_PROVIDER_SLUGS.apigeeEdge,
    title: "Apigee Edge",
    description:
      "Connect to Apigee Edge SaaS to sync API proxies, products, and developer apps.",
    addPath: connectorAddPath(CONNECTOR_PROVIDER_SLUGS.apigeeEdge),
    defaultManagementApiUrl: "https://api.enterprise.apigee.com",
    showGcpFields: false,
    showRuntimeRegion: false,
  },
  {
    id: "apigee-opdk",
    slug: CONNECTOR_PROVIDER_SLUGS.apigeeOpdk,
    title: "Apigee OPDK",
    description:
      "Connect to an on-premises Apigee (OPDK) deployment for API management integration.",
    addPath: connectorAddPath(CONNECTOR_PROVIDER_SLUGS.apigeeOpdk),
    defaultManagementApiUrl: "https://your-opdk-host:9000",
    showGcpFields: false,
    showRuntimeRegion: false,
  },
  {
    id: "apigee-hybrid",
    slug: CONNECTOR_PROVIDER_SLUGS.apigeeHybrid,
    title: "Apigee Hybrid",
    description:
      "Connect to Apigee hybrid runtime linked to Google Cloud for split control/data plane.",
    addPath: connectorAddPath(CONNECTOR_PROVIDER_SLUGS.apigeeHybrid),
    defaultManagementApiUrl: "https://apigee.googleapis.com",
    showGcpFields: true,
    showRuntimeRegion: true,
  },
  {
    id: "apigee-x",
    slug: CONNECTOR_PROVIDER_SLUGS.apigeeX,
    title: "Apigee X",
    description:
      "Connect to Apigee X on Google Cloud for fully managed API management.",
    addPath: connectorAddPath(CONNECTOR_PROVIDER_SLUGS.apigeeX),
    defaultManagementApiUrl: "https://apigee.googleapis.com",
    showGcpFields: true,
    showRuntimeRegion: false,
  },
];

export function getConnectorProviderTile(
  slug: string,
): ConnectorProviderTileConfig | undefined {
  return CONNECTOR_PROVIDER_TILES.find((tile) => tile.slug === slug);
}

export function getConnectorProviderTileById(
  id: ConnectorProviderType,
): ConnectorProviderTileConfig | undefined {
  return CONNECTOR_PROVIDER_TILES.find((tile) => tile.id === id);
}
